<app-navbar [navList]="navList"></app-navbar>

@let users = (users$ | async) || undefined;

<div class="row qai-content-box overflow-auto">

    <div class="col-md-4 p-4 pe-2">

        @if (users && users.length > 0) {
        <p class="fw-bolder" i18n>Utenti Disponibili</p>

        <form class="pb-4">
            <div class="input-group">
                <fa-icon [icon]="faSearch" class="qai-login-icon" style="color: lightgrey"></fa-icon>
                <input class="form-control qai-form-control_search rounded-3 bg-white"
                    type="search" i18n-placeholder placeholder="Cerca Utenti..." [(ngModel)]="searchValue"
                    [ngModelOptions]="{standalone: true}" i18n-aria-label aria-label="Search">
            </div>
        </form>

        <ul class="list-group rounded-3 shadow-sm">
            @for (user of getFilteredUsers(users); track $index) {
            <li class="list-group-item qai-linkable-item d-flex justify-content-between align-items-start p-0">
                <div class="ms-2 me-auto p-3 text-truncate">
                    <div class="fw-bolder text-truncate">{{ user.name }} {{ user.surname }}</div>
                    {{ user.email }}
                </div>
                <div class="align-self-center">
                    <button type="button" class="btn btn-primary tas-link-entity-button shadow ps-4 pe-3"
                        (click)="addUserToGroup(user.uid)">
                        <span class="me-2" i18n>Aggiungi</span>
                        <fa-icon [icon]="faArrowRight" size="lg"></fa-icon>
                    </button>
                </div>
            </li>
            }
        </ul>

        } @else if (users && users.length === 0) {
        <p class="fw-bolder" i18n>Nessun Utente Disponibile</p>
        }

    </div>

    <div class="col-md-8 p-4 ps-2">

        @let groupDetail = groupDetail$ | async;

        @if (groupDetail) {
        <div class="card tas-title-card shadow-sm">
            <form [formGroup]="groupForm" (ngSubmit)="updateGroup()">
                <div class="card-body">
                    <div class="card-title d-flex justify-content-between">
                        <div class="col-6">
                            <input type="text"
                                class="form-control qai-card-form qai-card-form-primary qai-card-form_title" id="name"
                                formControlName="name" aria-label="input group name">
                        </div>
                        @if (!editMode) {
                        <button class="btn btn-light rounded-3 py-1 my-1" type="button"
                            (click)="toggleEditMode(true)" i18n>
                            Modifica
                        </button>
                        } @else {
                        <button class="btn btn-light rounded-3 py-1 my-1" type="submit" i18n>
                            Salva
                        </button>
                        }
                    </div>
                    <h6 class="card-subtitle mb-3">
                        <div class="col-6">
                            <input type="text" class="form-control qai-card-form qai-card-form-primary fst-italic"
                            id="description" formControlName="description" aria-label="input group description">
                        </div>
                        <span class="visually-hidden" i18n>Group Description</span>
                    </h6>
                    <p class="ps-3 card-text" i18n>Utenti {{ groupDetail.users.length }} | Contesti {{
                        groupDetail.contexts.length }}</p>
                </div>
            </form>
        </div>

        <div class="my-3">
            <app-list [items]="groupDetail.users" [columns]="['name', 'surname', 'email']" [loading]="loading"
                (deleteRow)="removeUserFromGroup($event, 'remove')" (rowClick)="goToUserDetail($event)">
            </app-list>
        </div>

        }

    </div>


</div>